import { EntityDescriptor } from '../business-logic';
import { ticketsSchema } from '../schemas/tickets';

export const ticketEntity: EntityDescriptor = {
	tickets: {
		schema: ticketsSchema,
		migrationStrategies: {
			1: (oldDoc) => oldDoc,
		},
	},
};
